import { createFileRoute } from "@tanstack/react-router";
import { LadderBuilder } from "@/components/notices/ladders/ladder-builder";

export const Route = createFileRoute("/_authenticated/notices/rules/new")({
  component: NewNoticeLadderRoute,
});

/** Author a new escalation ladder. The page owns its own width wrapper. */
function NewNoticeLadderRoute() {
  return <LadderBuilder ladderId={null} />;
}
